import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export default {
  name: 'editableCellInput',
  props: {
    text: {},
    align: String,
    slotName: String,
    errStatus: {},
    errContent: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      value: this.text,
      err: this.errStatus
    };
  },
  watch: {
    text: function text() {
      this.value = this.text;
    },
    errStatus: function errStatus() {
      this.err = this.errStatus;
    }
  },
  methods: {
    handleChange: function handleChange(e) {
      var _this = this;
      var value = e.target.value;
      // 商品编号：实时格式化（全角转半角 + 仅留半角字母数字 + 转大写）
      if (this.slotName == "productNo") {
        var formatValue = this.formatProductNo(value);
        this.value = value;
        this.$nextTick(function () {
          _this.value = formatValue;
        });
      } else {
        this.value = value;
      }
      if (this.slotName == "productNo" || this.slotName == "productChannelid" || this.slotName == "productPrice" || this.slotName == "productStocknum" || this.slotName == "productSkuno") {
        if (this.slotName == "productStocknum") {
          // 库存数字：0 也算有值
          this.err = this.value || this.value == 0 ? false : true;
        } else {
          // 商品编号等：仅判空（商品编号格式已由 formatProductNo 保证）
          this.err = this.value ? false : true;
        }
      }
      this.check();
    },
    // 全角转半角 + 仅保留半角字母数字 + 转大写
    formatProductNo: function formatProductNo(str) {
      if (!str) return '';
      // 1. 全角字符（U+FF01~U+FF5E）整体转为半角（U+0021~U+007E），如全角字母数字ＡＢ１２ → AB12
      var result = String(str).replace(/[\uFF01-\uFF5E]/g, function (ch) {
        return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0);
      });
      // 2. 仅保留半角字母和数字，其余（中文、符号、空格、全角空格等）删除
      result = result.replace(/[^a-zA-Z0-9]/g, '');
      // 3. 统一转大写
      return result.toUpperCase();
    },
    check: function check() {
      var obj = {
        value: this.value,
        errStatus: this.err
      };
      this.$emit('change', obj);
    }
  }
};